import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const StepThanksContent = styled.div`
  text-align: center;
  margin: 0 -40px;
  padding: 5px;
  > h2 {
    margin: 20px 0;
  }
  > h3 {
    margin-bottom: 10px;
  }
  @media ${device.tablet} {
    > h1 {
      font-size: 24px;
    }
    > h2 {
      font-size: 20px;
      margin-top: 10px;
    }
    > h3 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
    }
  }
`;

export const StepThanksConsider = styled.div`
  > p {
    font-weight: 700;
    text-align: left;
    margin: 10px 0;
  }
`;

export const StepThanksFree = styled.div`
  > p:nth-child(2),
  > p:nth-child(3) {
    font-weight: 700;
  }
`;

export const ReturnHomeBtnWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 32px;

  > a {
    padding: 8px 18px;
    background-color: #fbce37;

    border-radius: 4px;
    display: flex;
    align-items: center;
    color: #000;
    font-weight: 700;
  }

  @media ${device.tablet} {
    > a {
      font-size: 14px;
    }
  }
`;
